/*
 * Presumably because of react's `Suspense`, sometimes the element doesn't exist yet when this component
 * is rendered, so we need to wait for it to become present with a `MutationObserver` before we try to
 * scroll to it. Based on https://stackoverflow.com/a/61511955
 */
export function waitForElement(selector: string) {
  return new Promise<Element>((resolve) => {
    if (document.querySelector(selector)) {
      resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}

export const scrollToElement = (element: Element) => {
  element.scrollIntoView({
    behavior: "smooth",
    inline: "nearest",
  });
};
